import logo from "@/assets/logo.jpeg";

export function Logo({ className = "h-10", showText = false }) {
  return (
    <div className="flex items-center gap-2">
      <img src={logo} alt="Certalyth Academy" className={`${className} rounded-md object-contain bg-white/95 p-0.5`} />
      {showText && (
        <span className="font-display font-extrabold text-lg tracking-tight text-white">
          Certalyth<span className="text-gold">.</span>
        </span>
      )}
    </div>
  );
}
